$(document).ready(function () {
  const widths = [200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500];
  let ranges = {};

  function addRange(glassType, values) {
    ranges[glassType] = {};
    for (let i = 0; i < widths.length; i++) {
      ranges[glassType][widths[i]] = values[i];
    }
  }

  function buildRanges(profilramme) {
    ranges = {};
    var tykkelse = $('input[name="properties[tykkelse]"]:checked').attr('data-tykkelse');
    if (tykkelse == 0) {
        addRange("Klar glas", [1695, 1815, 1935, 2060, 3050, 3170, 3295, 3415, 3535, 3660, 3780, 3905, 4025, 4085]);
        addRange("Klar Jernfattig", [2170, 2365, 3425, 3620, 3810, 4005, 4195, 4390, 4585, 4775, 4970, 5160, 5355, 5450]);
        addRange("Materet glas", [2035, 3165, 3425, 3685, 3945, 4205, 4465, 4725, 4985, 5245, 5500, 5760, 6020, 6150]);
        addRange("Røgfarvet glas", [1870, 2065, 3125, 3320, 3510, 3705, 3895, 4090, 4285, 4475, 4670, 4860, 5055, 5150]);
        addRange("Bronzefarvet glas", [1870, 2065, 3125, 3320, 3510, 3705, 3895, 4090, 4285, 4475, 4670, 4860, 5055, 5150]);
        addRange("Striped 3D", [2445, 2445, 2445, 2745, 2945, 3145, 3345, 3445, 3645, 3845, 4045, 4245, 4445, 4645]);
        addRange("Riflet glas", [3385, 3835, 4285, 4735, 5185, 5635, 6085, 6535, 6985, 7435, 7885, 8335, 8790, 9015]);
    } else {
        addRange("Klar glas", [2295, 2415, 2535, 2660, 3650, 3770, 3895, 4015, 4135, 4260, 4380, 4505, 4625, 4685]);
        addRange("Klar Jernfattig", [2770, 2965, 4025, 4220, 4410, 4605, 4795, 4990, 5185, 5375, 5570, 5760, 5955, 6050]);
        addRange("Materet glas", [2635, 3765, 4025, 4285, 4545, 4805, 5065, 5325, 5585, 5845, 6100, 6360, 6620, 6750]);
        addRange("Røgfarvet glas", [2470, 2665, 3725, 3920, 4110, 4305, 4495, 4690, 4885, 5075, 5270, 5460, 5655, 5750]);
        addRange("Bronzefarvet glas", [2470, 2665, 3725, 3920, 4110, 4305, 4495, 4690, 4885, 5075, 5270, 5460, 5655, 5750]);
        addRange("Striped 3D", [3045, 3045, 3045, 3445, 3545, 3945, 4345, 4845, 5245, 5645, 6045, 6445, 6845, 7245]);
        addRange("Riflet glas", [5045, 5045, 5045, 5445, 5545, 5945, 6345, 6845, 7245, 7645, 8045, 8445, 8845, 9245]);
    }
  }

  // function getNearestWidth(width) {
  //   return widths.reduce((prev, curr) =>
  //     Math.abs(curr - width) < Math.abs(prev - width) ? curr : prev
  //   );
  // }
function getNearestWidth(width) {
  let w = Math.floor(width / 100) * 100;

  // Ensure it stays within allowed range
  if (w < 200) w = 200;
  if (w > 1500) w = 1500;

  return w;
}
  function getHeightSurcharge(height) {
    if (height <= 2000) return 0;
    if (height <= 2100) return 199;
    if (height <= 2200) return 299;
    if (height <= 2300) return 399;
    if (height <= 2400) return 499;
    if (height >= 2401) return 499;
    return 0;
  }

    const profilrammePrices = {
    "Blank Krom": 450,
    "Børstet": 450,
    "Messing": 500,
    "Børstet messing": 900,
    "Sort": 600,
    "Børstet kobber": 1100
};
function updateProfilrammePrice() {
    const profilrammeValue = $('input[name="properties[Profilramme]"]:checked').val();
    const profilfarveValue = $('input[name="properties[Profilfarve]"]:checked').val();

    if (profilrammeValue === 'Med profilramme') {
        profilramme = profilrammePrices[profilfarveValue];
    } else {
        profilramme = 0;
    }

}

 $('input[name="properties[Profilramme]"]').on('change', function () {
    const profilrammevalue = $(this).val();
    if(profilrammevalue == 'Med profilramme'){
          updateProfilrammePrice();
    updateTotalPrice();
    }
 });

  function updateTotalPrice() {
    updateProfilrammePrice();
    const bredde = parseInt($('#bredde').val(), 10) || 200;
    const calchojde = parseInt($('#calchojde').val(), 10) || 2000;
    const glasType = $('input.glass-frame-box:checked').val();

    const profilfarvePrice = parseFloat($('input[name="properties[Profilfarve]"]:checked').data("price")) || 0;
    const endekappePrice = parseFloat($('input[name="properties[Endekappe]"]:checked').data("endekappe")) || 0;
    const belgningPrice = parseFloat($('input[name="properties[Belægning]"]:checked').data("belgning")) || 0;

    buildRanges(profilramme);
    const widthKey = getNearestWidth(bredde);
    const basePrice = ranges[glasType]?.[widthKey] || 0;
    const heightSurcharge = getHeightSurcharge(calchojde);

    console.log(heightSurcharge);

    var totle_area = parseFloat(bredde / 1000) * parseFloat(calchojde / 1000);

    var new_totle_price_area = parseFloat(belgningPrice) * parseFloat(totle_area);

    // console.log(totle_area);
    // console.log(new_totle_price_area);

    // const totalPrice = Math.floor(basePrice + profilfarvePrice + endekappePrice + profilramme + belgningPrice + heightSurcharge);
    const totalPrice = Math.floor(basePrice + profilfarvePrice + endekappePrice + profilramme + new_totle_price_area + heightSurcharge);

    $("#custom-priceTicker")
      .attr("data-main-price", basePrice)
      .attr("data-total-price", totalPrice)
      .text(totalPrice);
    $(".product-sticky-form__price").text(totalPrice + ' kr');
    $("#custom-qty").val(totalPrice);
  }
  // Handle thickness selection
  $('input[name="properties[tykkelse]"]').on('change', function () {
    const selectedThickness = $(this).val();
    const mainPrice = selectedThickness === '10mm' ? 2295 : 1695;

    $('#custom-priceTicker')
      .attr('data-main-price', mainPrice)
      .attr('data-glass-price', mainPrice);

    if (selectedThickness === "10mm") {
      $("#glas-riflet-glas").prop("checked", false).prop("disabled", true);
      $('label[for="glas-riflet-glas"]').addClass("hide-now");
    } else {
      $("#glas-riflet-glas").prop("disabled", false);
      $('label[for="glas-riflet-glas"]').removeClass("hide-now");
    }
    updateTotalPrice();
  });

  // Disable/enable "Striped 3D"
  $("#glas-striped-3d").prop("checked", false).prop("disabled", true);
  $('label[for="glas-striped-3d"]').addClass("hide-now");

  $('input[name="properties[Profilramme]"]').on('change', function () {
    var selectedValue = $('input[name="properties[Profilramme]"]:checked').val();
    if (selectedValue === 'Med profilramme') {
      $("#glas-striped-3d").prop("disabled", false);
      $('label[for="glas-striped-3d"]').removeClass("hide-now");
    } else {
      $("#glas-striped-3d").prop("checked", false).prop("disabled", true);
      $('label[for="glas-striped-3d"]').addClass("hide-now");
    }
    updateTotalPrice();
  });
document.getElementById('AddToCart').addEventListener('click', function () {
  updateTotalPrice();
});

window.addEventListener('load', function () {
  updateTotalPrice();
});

window.addEventListener('pageshow', function (event) {
  updateTotalPrice();
});

  
  // Event listeners
  $("#bredde, #calchojde").on("input", updateTotalPrice);
  $("input.glass-frame-box").on("change", updateTotalPrice);
  $('input[name="properties[Profilfarve]"]').on("change", updateTotalPrice);
  $('input[name="properties[Profilramme]"]').on("change", updateTotalPrice);
  $('input[name="properties[Endekappe]"]').on("change", updateTotalPrice);
  $('input[name="properties[Belægning]"]').on("change", updateTotalPrice);

  // $('.custom-radio-input.profilfarve').on('change', function () {
  //   var selectedTitle = $(this).val().trim();
  //   $('.profilfarve-heading').text('Vælg glastype med ' + selectedTitle.toLowerCase() + ' profilfarve');
  // });

  updateTotalPrice(); // Initial call on page load
   var limitInput = function() {
        var value = parseInt(this.value, 10);
        var max = parseInt(this.max, 10);
        var min = parseInt(this.min, 10);
        
        if (value > max) {
            this.value = max;
        } else if (value < min) {
            this.value = min;
        }
    };
    document.getElementById("bredde").addEventListener("change", limitInput);
    document.getElementById("calchojde").addEventListener("change", limitInput);
  });
function updateImageBySelections() {
  const profilrammeVal = $('input[name="properties[Profilramme]"]:checked').val();
  const profilfarveVal = $('input[name="properties[Profilfarve]"]:checked').val();

  let newImgSrc = '';

  if (profilrammeVal === 'Ingen profilramme') {
    if (profilfarveVal === 'Blank Krom') {
      newImgSrc = $('.glass-frame-box:checked').data('img');
    } else if (profilfarveVal === 'Børstet') {
      newImgSrc = $('.glass-frame-box:checked').data('img-børstet');
    } else if (profilfarveVal === 'Messing') {
      newImgSrc = $('.glass-frame-box:checked').data('img-messing');
      } else if (profilfarveVal === 'Børstet messing') {
      newImgSrc = $('.glass-frame-box:checked').data('img-borstet-messing');
    } else if (profilfarveVal === 'Sort') {
      newImgSrc = $('.glass-frame-box:checked').data('img-sort');
    } else if (profilfarveVal === 'Børstet kobber') {
      newImgSrc = $('.glass-frame-box:checked').data('img-kobber');
    }
  } else if (profilrammeVal === 'Med profilramme') {
    if (profilfarveVal === 'Blank Krom') {
      newImgSrc = $('.glass-frame-box:checked').data('img-frame');
    } else if (profilfarveVal === 'Børstet') {
      newImgSrc = $('.glass-frame-box:checked').data('img-børstet-frame');
    } else if (profilfarveVal === 'Messing') {
      newImgSrc = $('.glass-frame-box:checked').data('img-messing-frame');
    } else if (profilfarveVal === 'Børstet messing') {
      newImgSrc = $('.glass-frame-box:checked').data('img-borstet-messing-frame');
    } else if (profilfarveVal === 'Sort') {
      newImgSrc = $('.glass-frame-box:checked').data('img-sort-frame');
    } else if (profilfarveVal === 'Børstet kobber') {
      newImgSrc = $('.glass-frame-box:checked').data('img-kobber-frame');
    }
  }

  
 const selectedRadio = $('.glass-frame-box .custom-radio-input:checked').val();

  if (newImgSrc) {
    $('.update-img img').attr('src', newImgSrc).removeAttr('srcset');
    $('.pswp__img').attr('src', newImgSrc).removeAttr('srcset');
  }
}

// Run when any relevant input changes
$(document).ready(function () {
  $('input[name="properties[Profilramme]"], input[name="properties[Profilfarve]"], .custom-radio-input').on('change', updateImageBySelections);

  // Trigger once on page load
  updateImageBySelections();
    setInterval(function() {
      updateImageBySelections();
    }, 10); // interval
});
$(document).on('click', '.product__zoom-button', function() {
      setInterval(function() {
      updateImageBySelections();
            }, 10); // interval
});


$(document).on('change', 'input[name="properties[Profilfarve]"]', function () {
    var value = $(this).val();

    if (value === "Børstet kobber" || value === "Børstet messing") {
       var isMedEndekappe = $('input[name="properties[Endekappe]"]:checked').val() !== "Uden endekappe";
       var checkedEndekappe = $('input[name="properties[Endekappe]"]:checked');
      if (isMedEndekappe) {
        var endekappePrice = parseFloat(checkedEndekappe.data('endekappe')) || 0;
                var priceLabel = $('#custom-priceTicker');
                var currentTotal = parseFloat(priceLabel.data('total-price'));
                var newTotal = currentTotal - endekappePrice;
          priceLabel.attr('data-total-price', newTotal);
          priceLabel.text(newTotal);
      }
        $('input[name="properties[Endekappe]"][value="Uden endekappe"]').prop('checked', true);
        $('input[name="properties[Endekappe]"]').prop('disabled', true);
    } else {
        $('input[name="properties[Endekappe]"]').prop('disabled', false);
    }
});







// Glastyper-side: load første frame og spil kun ved hover
(function() {
  function initGlassCardHover() {
    document.querySelectorAll('.glass-card').forEach(function(card) {
      var video = card.querySelector('video');
      if (!video || video.dataset.hoverInit) return;
      video.dataset.hoverInit = '1';
      // Fjern autoplay så videoen ikke starter automatisk
      video.removeAttribute('autoplay');
      // Load source nu for at vise første frame
      var source = video.querySelector('source[data-src]');
      if (source) {
        source.src = source.getAttribute('data-src');
        video.preload = 'metadata';
        video.load();
      }
      card.addEventListener('mouseenter', function() {
        video.play().catch(function() {});
      });
      card.addEventListener('mouseleave', function() {
        video.pause();
        video.currentTime = 0;
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlassCardHover);
  } else {
    initGlassCardHover();
  }
})();

// Global lazy-loader: autoplay videos med data-src (ikke hover-play)
(function() {
  function lazyLoadAutoplayVideos() {
    var videos = document.querySelectorAll('video[preload="none"]:not([data-hover-play])');
    if (!videos.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var video = entry.target;
        var source = video.querySelector('source[data-src]');
        if (source && !source.getAttribute('src')) {
          source.src = source.getAttribute('data-src');
          video.load();
        }
        observer.unobserve(video);
      });
    }, { rootMargin: '200px', threshold: 0 });
    videos.forEach(function(v) { observer.observe(v); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lazyLoadAutoplayVideos);
  } else {
    lazyLoadAutoplayVideos();
  }
})();
